'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.PublikationSchema = {
  title: 'Publikation',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/publikation.js
// module id = AL2D
// module chunks = 0